export interface VersionInfo {
  major: string;
  minor: string;
  patch: string;
  postfix?: string;
}

export const getVersionInfo = (version: string): VersionInfo => {
  const versionPattern = /^(\d+)\.(\d+)\.(\d+)(?:-(.+))?$/;
  const match = version.match(versionPattern);

  if (!match) {
    throw new Error(`Invalid version format: ${version}`);
  }

  const [, major, minor, patch, postfix] = match;
  return {
    major,
    minor,
    patch,
    postfix,
  };
};
